import { useRoutes,HashRouter } from "react-router-dom";
import CssBaseline from "@mui/material/CssBaseline";

import { MatxTheme } from "./components";
// ALL CONTEXTS
// import { AuthProvider } from "./contexts/JWTAuthContext";
import SettingsProvider from "./contexts/SettingsContext";
// ROUTES
import routes from "./routes";



   
export default function App() {
  const content = useRoutes(routes);
  const isMobile = window.innerWidth < 600;
  
  
  return (
    <>
      {isMobile ? <div style={{display:"flex", flexDirection:"column", backgroundColor:"#4A585F", color:"white", minHeight:"100vh", alignItems:"center", justifyContent:"center"}}>
        <h3 style={{textAlign:"center"}}>Oops! Looks like you’re on a mobile device.</h3>
        <p style={{textAlign:"center", color:"lightgray"}}>This tool works best on a bigger screen. Kindly switch to your desktop or laptop.</p>
      </div> :
    <SettingsProvider>
      {/* <AuthProvider> */}
        <MatxTheme>
          <CssBaseline />
          {content}
         
        </MatxTheme>
      {/* </AuthProvider> */}
     </SettingsProvider>}
 
    </>
     );
}
